import Checkbox from './Checkbox';

export default Checkbox;


//////////////////
// WEBPACK FOOTER
// ./~/rc-checkbox/es/index.js
// module id = 1105
// module chunks = 0